// Career assessment (candidate-facing) page translations.
// Norwegian Bokmål is the default candidate language; the same strings are
// registered under both 'nb' (repo language code) and 'no' (backend code).
// Machine-translation quality — professional review is a separate workstream.

const nbTranslations = {
  header: {
    title: "Karrierekartlegging",
    subtitle: "Karrierehuset · QualiTaTi",
  },
  status: {
    loading: "Laster kartleggingen ...",
    starting: "Starter ...",
    submitting: "Sender ...",
    next: "Neste",
    previous: "Forrige",
    retry: "Prøv igjen",
  },
  errors: {
    load: "Kunne ikke laste kartleggingen. Sjekk at lenken er riktig, og prøv igjen.",
    start: "Kunne ikke starte økten. Prøv igjen.",
    submit: "Kunne ikke sende svaret. Sjekk tilkoblingen og prøv igjen.",
    form: "Kunne ikke sende skjemaet. Sjekk tilkoblingen og prøv igjen.",
  },
  progress: {
    label: "Fremdrift",
  },
  form: {
    title: "Bakgrunnsskjema",
    intro: "Dette hjelper rådgiveren å forstå situasjonen din — det tar ca. 3 minutter.",
    submit: "Fortsett",
    submitting: "Sender ...",
  },
  // Strings consumed by the shared CustomFormRenderer (background survey).
  session: {
    requiredField: "obligatorisk",
    fieldRequired: "{label} er obligatorisk",
    invalidEmail: "Oppgi en gyldig e-postadresse",
    invalidPhone: "Oppgi et gyldig telefonnummer",
    invalidNumber: "Oppgi et gyldig tall",
    sumMustEqual: "Verdiene må summere til {total} (nå: {sum})",
    constantSumInstruction: "Fordel totalt {total} poeng på alternativene nedenfor.",
    remaining: "Gjenstår:",
    yes: "Ja",
    no: "Nei",
    chooseFile: "Velg fil",
    chooseFileDrag: "Velg fil eller dra og slipp",
    fileSelected: "Fil valgt",
    fileTooLarge: "Filen må være mindre enn {size} MB",
    selectedPrefix: "Valgt:",
    acceptedPrefix: "Godtatte filtyper:",
    dragToReorder: "Dra for å endre rekkefølgen",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
    npsNotLikely: "Ikke sannsynlig i det hele tatt",
    npsExtremely: "Svært sannsynlig",
    optionN: "Alternativ {n}",
    surveyImageAlt: "Informasjonsbilde",
    unsupportedField: "Felttypen støttes ikke: {type}",
  },
  consent: {
    title: "Samtykke og personvern",
    greeting: "Hei {{name}}! Velkommen til kartleggingen for {{project}}.",
    intro: "Før du starter, ber vi deg lese gjennom og samtykke til hvordan svarene dine behandles.",
    purposeTitle: "Formål",
    purposeText: "Svarene dine brukes til å lage en karriereprofil som rådgiveren din hos Karrierehuset bruker i veiledningen din. Det finnes ingen riktige eller gale svar.",
    dataUseTitle: "Bruk av data",
    dataUseText: "Svarene dine behandles konfidensielt og deles kun med rådgiveren din. Vi bruker AI-verktøy til å analysere svarene og stille oppfølgingsspørsmål.",
    retentionTitle: "Lagring",
    retentionText: "Opplysningene lagres bare så lenge det er nødvendig for veiledningen din, og slettes deretter i tråd med gjeldende personvernregler.",
    rightsTitle: "Dine rettigheter (GDPR)",
    rights: [
      "Du kan be om innsyn i opplysningene som er lagret om deg",
      "Du kan be om retting av uriktige opplysninger",
      "Du kan be om sletting av opplysningene dine («retten til å bli glemt»)",
      "Du kan når som helst trekke tilbake samtykket ditt",
      "Du kan klage til Datatilsynet",
    ],
    consentLabel: "Jeg samtykker til at svarene mine behandles som beskrevet ovenfor",
    voiceConsentLabel: "Jeg samtykker også til at stemmen min kan tas opp og behandles i taledelen av kartleggingen",
    start: "Start kartleggingen",
    starting: "Starter ...",
    requiredHint: "Du må samtykke for å kunne starte.",
    voiceNeededHint: "Talemodus krever at du også samtykker til stemmebehandling — eller velg tekstmodus.",
    modalityTitle: "Hvordan vil du gjennomføre samtalen med AI-en?",
    modalityRealtime: "Sanntidssamtale — snakk ↔ snakk",
    modalityRealtimeDesc: "Som en telefonsamtale: AI-en svarer med stemme i sanntid, og du kan avbryte underveis.",
    modalityTextText: "Du skriver — AI-en skriver",
    modalityTextTextDesc: "Spørsmålene vises som tekst, og du skriver svarene dine.",
    modalityTextVoice: "Du skriver — AI-en snakker",
    modalityTextVoiceDesc: "Spørsmålene leses høyt for deg, og du skriver svarene.",
    modalityVoiceText: "Du snakker — AI-en skriver",
    modalityVoiceTextDesc: "Spørsmålene vises som tekst, og du svarer med stemmen (talen gjøres om til tekst).",
    modalityVoiceVoice: "Du snakker — AI-en snakker",
    modalityVoiceVoiceDesc: "Spørsmålene leses høyt, og du svarer med stemmen — tur for tur.",
  },
  question: {
    situation: "Situasjon",
  },
  likert: {
    low: "Stemmer ikke for meg",
    high: "Stemmer godt for meg",
  },
  rank: {
    instruction: "Bruk pilene til å rangere alternativene – 1 er det som passer best for deg.",
  },
  bestWorst: {
    instruction: "Marker det beste og det dårligste alternativet.",
    best: "Best",
    worst: "Dårligst",
  },
  ratingThenChoose: {
    ratingInstruction: "Hvor godt passer denne situasjonen for deg?",
    chooseInstruction: "Hvilket alternativ ville du valgt?",
    low: "Passer dårlig",
    high: "Passer godt",
  },
  chat: {
    aiLabel: "AI-utforsker",
    questionLabel: "Spørsmål",
    placeholder: "Skriv svaret ditt her (minst 10 tegn) ...",
    voicePlaceholder: "Snakk med mikrofonknappen, eller skriv svaret ditt her ...",
    minChars: "Svar med minst 10 tegn.",
    send: "Send",
    thinking: "Tenker ...",
    yes: "Ja",
    no: "Nei",
    you: "Du",
    history: "Tidligere i samtalen",
    listenAgain: "Hør spørsmålet igjen",
    micStart: "Snakk",
    micStop: "Stopp",
    listening: "Lytter ... snakk nå, og trykk Stopp når du er ferdig.",
    voiceUnsupported: "Nettleseren din støtter ikke tale til tekst — skriv svaret i stedet (prøv Chrome eller Edge).",
  },
  handoff: {
    title: "Bra jobbet! Ett steg igjen: samtalen",
    body: "Spørreskjemaene er fullført. Siste del er en samtale med AI-intervjueren — den tilpasser seg svarene dine underveis. Sett av 10–15 minutter i ro og fred.",
    start: "Start samtalen",
    alreadyHint: "Har du allerede gjennomført samtalen? Da er du ferdig, og rådgiveren din går gjennom resultatene.",
  },
  done: {
    title: "Takk! Kartleggingen er fullført",
    body: "Svarene dine er lagret. Din rådgiver går gjennom resultatene og tar dem med i neste veiledningssamtale.",
    noScores: "Du får ingen poengsum her – resultatene tolkes sammen med rådgiveren din.",
    alreadyTitle: "Kartleggingen er allerede fullført",
    alreadyBody: "Din rådgiver går gjennom resultatene. Ta kontakt med rådgiveren din hvis du har spørsmål.",
  },
};

const enTranslations = {
  header: {
    title: "Career Assessment",
    subtitle: "Karrierehuset · QualiTaTi",
  },
  status: {
    loading: "Loading the assessment ...",
    starting: "Starting ...",
    submitting: "Submitting ...",
    next: "Next",
    previous: "Previous",
    retry: "Try again",
  },
  errors: {
    load: "Could not load the assessment. Please check that the link is correct and try again.",
    start: "Could not start the session. Please try again.",
    submit: "Could not submit your answer. Check your connection and try again.",
    form: "Could not submit the form. Check your connection and try again.",
  },
  progress: {
    label: "Progress",
  },
  form: {
    title: "Background survey",
    intro: "This helps your advisor understand your situation — it takes about 3 minutes.",
    submit: "Continue",
    submitting: "Submitting ...",
  },
  // Strings consumed by the shared CustomFormRenderer (background survey).
  session: {
    requiredField: "required",
    fieldRequired: "{label} is required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    invalidNumber: "Please enter a valid number",
    sumMustEqual: "Values must sum to {total} (current: {sum})",
    constantSumInstruction: "Allocate a total of {total} points across the items below.",
    remaining: "Remaining:",
    yes: "Yes",
    no: "No",
    chooseFile: "Choose file",
    chooseFileDrag: "Choose file or drag & drop",
    fileSelected: "File selected",
    fileTooLarge: "File size must be less than {size}MB",
    selectedPrefix: "Selected:",
    acceptedPrefix: "Accepted:",
    dragToReorder: "Drag to reorder",
    moveUp: "Move up",
    moveDown: "Move down",
    npsNotLikely: "Not at all likely",
    npsExtremely: "Extremely likely",
    optionN: "Option {n}",
    surveyImageAlt: "Survey information",
    unsupportedField: "Unsupported field type: {type}",
  },
  consent: {
    title: "Consent and privacy",
    greeting: "Hi {{name}}! Welcome to the assessment for {{project}}.",
    intro: "Before you start, please read and consent to how your answers are processed.",
    purposeTitle: "Purpose",
    purposeText: "Your answers are used to build a career profile that your advisor at Karrierehuset uses in your guidance. There are no right or wrong answers.",
    dataUseTitle: "Use of data",
    dataUseText: "Your answers are treated confidentially and shared only with your advisor. We use AI tools to analyze your answers and ask follow-up questions.",
    retentionTitle: "Retention",
    retentionText: "Your data is stored only as long as needed for your guidance and is then deleted in line with applicable privacy regulations.",
    rightsTitle: "Your rights (GDPR)",
    rights: [
      "You can request access to the data stored about you",
      "You can request correction of inaccurate data",
      "You can request deletion of your data (the \"right to be forgotten\")",
      "You can withdraw your consent at any time",
      "You can lodge a complaint with the Norwegian Data Protection Authority",
    ],
    consentLabel: "I consent to my answers being processed as described above",
    voiceConsentLabel: "I also consent to my voice being recorded and processed in the voice part of the assessment",
    start: "Start the assessment",
    starting: "Starting ...",
    requiredHint: "You must consent in order to start.",
    voiceNeededHint: "Voice mode also requires consent to voice processing — or pick a text mode.",
    modalityTitle: "How would you like to run the conversation with the AI?",
    modalityRealtime: "Live conversation — speak ↔ speak",
    modalityRealtimeDesc: "Like a phone call: the AI answers with live speech, and you can interrupt at any time.",
    modalityTextText: "You write — AI writes",
    modalityTextTextDesc: "The questions appear as text, and you type your answers.",
    modalityTextVoice: "You write — AI speaks",
    modalityTextVoiceDesc: "The questions are read aloud to you, and you type your answers.",
    modalityVoiceText: "You speak — AI writes",
    modalityVoiceTextDesc: "The questions appear as text, and you answer by speaking (speech is turned into text).",
    modalityVoiceVoice: "You speak — AI speaks",
    modalityVoiceVoiceDesc: "The questions are read aloud, and you answer by speaking — turn by turn.",
  },
  question: {
    situation: "Situation",
  },
  likert: {
    low: "Not like me",
    high: "Very much like me",
  },
  rank: {
    instruction: "Use the arrows to rank the options — 1 is the one that fits you best.",
  },
  bestWorst: {
    instruction: "Mark the best and the worst option.",
    best: "Best",
    worst: "Worst",
  },
  ratingThenChoose: {
    ratingInstruction: "How well does this situation fit you?",
    chooseInstruction: "Which option would you choose?",
    low: "Poor fit",
    high: "Good fit",
  },
  chat: {
    aiLabel: "AI explorer",
    questionLabel: "Question",
    placeholder: "Write your answer here (at least 10 characters) ...",
    voicePlaceholder: "Speak using the microphone button, or type your answer here ...",
    minChars: "Please answer with at least 10 characters.",
    send: "Send",
    thinking: "Thinking ...",
    yes: "Yes",
    no: "No",
    you: "You",
    history: "Earlier in the conversation",
    listenAgain: "Hear the question again",
    micStart: "Speak",
    micStop: "Stop",
    listening: "Listening ... speak now, and press Stop when you are done.",
    voiceUnsupported: "Your browser does not support speech-to-text — please type your answer instead (try Chrome or Edge).",
  },
  handoff: {
    title: "Well done! One step left: the conversation",
    body: "The questionnaires are complete. The final part is a conversation with the AI interviewer — it adapts to your answers as you go. Set aside 10–15 quiet minutes.",
    start: "Start the conversation",
    alreadyHint: "Already completed the conversation? Then you are done — your advisor will review the results.",
  },
  done: {
    title: "Thank you! The assessment is complete",
    body: "Your answers have been saved. Your advisor will review the results and bring them into your next guidance session.",
    noScores: "You will not see a score here — the results are interpreted together with your advisor.",
    alreadyTitle: "This assessment has already been completed",
    alreadyBody: "Your advisor is reviewing the results. Please contact your advisor if you have any questions.",
  },
};

export const careerAssessmentTranslations = {
  en: enTranslations,
  nb: nbTranslations,
  no: nbTranslations,
};
